// @flow

import isNil from 'lodash/isNil';

export default function mapBoolean(value: any): boolean {
  return isNil(value) ? value : value === 'true' || value === true;
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/shared/SearchNotifications/adapters/subscriptionQueryMapper/mapBoolean.js